/** @import modules */

import { createContext } from "react";

/** @create context */

export const CartContext = createContext ( null );